import countryList from "astrid-config/src/countries";

export default function displaySelectedCountries(countries) {
	if (countries?.[0] === "WORLD" || !countries?.length) {
		return "WORLD";
	}

	const mapped = countries
		?.map((countryCode) => {
			return countryList?.[countryCode];
		})
		.slice(0, 2);

	if (countries?.length > mapped?.length) {
		return `${mapped.join(", ")}...`;
	}

	return mapped?.join(", ");
}
